import { createReducer, on } from '@ngrx/store';
import { identityCardActions } from '../identity_card.actions';

export interface CiExcelState {
    data: Blob | null;
}

export const initialState: CiExcelState = { data: null };

export const ciExcelReducer = createReducer(
    initialState,
    on(identityCardActions.getExcelSuccess, (state, { payload }) => ({ ...state, data: payload })),
    on(identityCardActions.clearExcel, () => initialState)
);
